export default "__VITE_ASSET__DjmJIvhV__"